module.exports = __webpack_public_path__ + "img/1.png.2a77ea6f.webp";